var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMathFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8125 48.2077L52.7917 40.1868L56 36.9785L60.8125 41.791L70.4375 32.166L73.6459 35.3743L60.8125 48.2077ZM48.2084 39.041H27.5834V43.6243H48.2084V39.041ZM71.125 53.7077L67.9167 50.4993L61.9584 56.4577L56 50.4993L52.7917 53.7077L58.75 59.666L52.7917 65.6243L56 68.8327L61.9584 62.8743L67.9167 68.8327L71.125 65.6243L65.1667 59.666L71.125 53.7077ZM48.2084 57.3743H27.5834V61.9577H48.2084V57.3743Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathFrame);
export default __webpack_public_path__ + "static/media/mathFrame.dc3b7021a6a1795a9a8f219d56644581.svg";
export { ForwardRef as ReactComponent };